/**
 * CIBLES TACTILES (WCAG 2.2 SC 2.5.8 « Target Size (Minimum) », 24×24 px minimum ;
 * 44×44 px = recommandation AAA 2.5.5 et pratique courante mobile).
 *
 * Le projet a l'habitude des classes partagées (cf. `TAB_LINK_CLASS`) : ces deux
 * constantes évitent que chaque bouton-icône reparte d'un `p-1` arbitraire, comme
 * c'était le cas — barre d'outils à 20 px, cloche de notifications à 24 px (dont
 * « Annuler un job », DESTRUCTIF), fil d'Ariane à 28 px.
 *
 * - `ICON_BUTTON_SIZE` : bouton-icône CARRÉ (l'icône est le seul contenu).
 * - `TOUCH_TARGET` : plancher à AJOUTER à un bouton dont la taille vient déjà de son
 *   contenu (texte + icône). Ne change ni le rembourrage ni la typographie : il
 *   garantit seulement la surface cliquable.
 */

/** Bouton-icône carré de 44×44 px, contenu centré. */
export const ICON_BUTTON_SIZE = 'inline-flex h-11 w-11 items-center justify-center';

/** Plancher 44×44 px pour un bouton dimensionné par son contenu. */
export const TOUCH_TARGET = 'min-h-11 min-w-11';
